import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Card from "../components/Card";
import aboutImage from "../assets/about.jpg";
import heroImage from "../assets/hero.jpg";
import deepEarth from "../assets/image-deep-earth.jpg";
import nightArcade from "../assets/image-night-arcade.jpg";
import soccerTeamVR from "../assets/image-soccer-team.jpg";
import theGrid from "../assets/image-grid.jpg";
import fromAboveVR from "../assets/image-from-above.jpg";
import pocketBorealis from "../assets/image-pocket-borealis.jpg";
import theCuriosity from "../assets/image-curiosity.jpg";
import makeItFisheye from "../assets/image-fisheye.jpg";

const creationsData = [
  { image: deepEarth, title: "DEEP EARTH" },
  { image: nightArcade, title: "NIGHT ARCADE" },
  { image: soccerTeamVR, title: "SOCCER TEAM VR" },
  { image: theGrid, title: "THE GRID" },
  { image: fromAboveVR, title: "FROM ABOVE VR" },
  { image: pocketBorealis, title: "POCKET BOREALIS" },
  { image: theCuriosity, title: "THE CURIOSITY" },
  { image: makeItFisheye, title: "MAKE IT FISHEYE" },
];

function Home() {
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const parallax = document.querySelector(".parallax");
      if (parallax) {
        parallax.style.backgroundPositionY = `${-scrollPosition * 0.5}px`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

   useEffect(() => {
    window.scrollTo(0, 10);
  }, []);


  return (
    <div>
      <div
        className="parallax"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <Navbar />
        <div className="hero-text">
          <h1 className="text-white">IMMERSIVE EXPERIENCES THAT DELIVER</h1>
        </div>
      </div>
      <section id="about" className="py-5 position-relative">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-12 col-md-7 mb-4 mb-md-0">
              <img
                src={aboutImage}
                alt="About"
                className="img-fluid w-100 rounded"
              />
            </div>
            <div
              className="col-12 col-md-5  p-5 shadow-sm position-md-absolute end-0 bottom-0"
              style={{
                backgroundColor: "rgba(206, 13, 245, 0.12)",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(255, 105, 180, 0.3)",
              }}
            >
              <h2 className="font-josefin font-light text-4xl text-uppercase mb-3">
                THE LEADER IN INTERACTIVE VR
              </h2>
              <p className="font-alata text-secondary line-height-relaxed">
                Founded in 2011, Loopstudios has been producing world-class
                virtual reality projects for some of the best companies around
                the globe.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="creations" className="py-5">
        <div className="container">
          <div className="row align-items-center mb-4">
            <div className="col-12 col-md-6">
              <h2 className="font-josefin font-light text-4xl text-uppercase">
                OUR CREATIONS
              </h2>
            </div>
            <div className="col-12 col-md-6 text-end">
              <button className="btn btn-outline-dark text-uppercase px-4 py-2">
                SEE ALL
              </button>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
            {creationsData.map((item, index) => (
              <div key={index} className="col">
                <Card image={item.image} title={item.title} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Home;
